import { render, staticRenderFns } from "./changeSpecificationsModal.vue?vue&type=template&id=22471213&scoped=true"
import script from "./changeSpecificationsModal.vue?vue&type=script&lang=js"
export * from "./changeSpecificationsModal.vue?vue&type=script&lang=js"
import style0 from "./changeSpecificationsModal.vue?vue&type=style&index=0&id=22471213&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22471213",
  null
  
)

export default component.exports